import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import CheckComplete from "./pages/CheckComplete";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/check-complete" element={<CheckComplete />} />
      </Routes>
    </Router>
  );
}

export default App;
